import React from 'react'
import PropTypes from 'prop-types'
import { Card, Empty } from 'antd'
import { Doughnut } from 'react-chartjs-2'
import { doughnutData, doughnutOptions, colorAt } from './utils'

// A breakdown card: a doughnut of the segment counts on the left and, on the right, a legend
// listing each segment with its count and percentage-of-total. Used once per service section
// (cars, conversations, duty requests, duty documents, payments).
const SegmentBreakdown = ({ title, total, segments, extra, onSegmentClick }) => {
  const hasData = total > 0

  return (
    <Card title={title} extra={extra} style={{ height: '100%' }}>
      {!hasData ? (
        <Empty description="No data for this period" />
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16 }}>
          <div style={{ width: 160, height: 160, flexShrink: 0 }}>
            <Doughnut data={doughnutData(segments)} options={doughnutOptions} />
          </div>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: 600,
                marginBottom: 8
              }}
            >
              <span>Total</span>
              <span>{total}</span>
            </div>
            {segments.map((s, i) => (
              <div
                key={s.key}
                onClick={onSegmentClick ? () => onSegmentClick(s) : undefined}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '4px 0',
                  cursor: onSegmentClick ? 'pointer' : 'default'
                }}
              >
                <span
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: 2,
                    background: colorAt(i),
                    flexShrink: 0
                  }}
                />
                <span style={{ flex: 1, color: '#555' }}>{s.label}</span>
                <span style={{ fontWeight: 600 }}>{s.count}</span>
                <span style={{ width: 56, textAlign: 'right', color: '#888' }}>
                  {s.percentage}%
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  )
}

SegmentBreakdown.propTypes = {
  title: PropTypes.node,
  total: PropTypes.number,
  segments: PropTypes.array,
  extra: PropTypes.node,
  onSegmentClick: PropTypes.func
}

export default SegmentBreakdown
